<template>
  <div class="grid grid-cols-6 bg-white mb-8">
    <div class="grid grid-cols-6 col-span-6 border-b-2  border-gray-400 bg-gray-200">
      <div class="col-span-3 px-3 py-3.5 text-sm text-left">{{ $t('Name') }}</div>
      <div class="px-3 py-3.5 text-sm text-center overflow-ellipsis overflow-hidden whitespace-nowrap">{{ $t('Hide') }}</div>
      <div class="px-3 py-3.5 text-sm text-center overflow-ellipsis overflow-hidden whitespace-nowrap">{{ $t('View') }}</div>
      <div class="px-3 py-3.5 text-sm text-center overflow-ellipsis overflow-hidden whitespace-nowrap">{{ $t('Edit') }}</div>
    </div>
    <access-tree
      v-for="(node, i) in tree"
      :node="node"
      :key="node.id"
      :depth="0"
      :is-first="true"
      :pre-branches-to-hide="i+1 === tree.length ? [0] : []"
      :parent-right="null"
    />
  </div>
</template>

<script>
export default {
  props: ['tree']
}
</script>

<style lang="scss" scoped></style>
